import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultRtlContextProps = {
  writingMode: 'horizontal-tb',
  direction: 'ltr',
  textOrientation: 'mixed'
};
const WritingModeContext = /*#__PURE__*/createContext(defaultRtlContextProps);
export const WritingModeConsumer = WritingModeContext.Consumer;
export const WritingModeProvider = props => {
  const value = useMemo(() => ({
    writingMode: props.writingMode || defaultRtlContextProps.writingMode,
    direction: props.direction || defaultRtlContextProps.direction,
    textOrientation: props.textOrientation || defaultRtlContextProps.textOrientation
  }), [props.writingMode, props.direction, props.textOrientation]);
  return /*#__PURE__*/_jsx(WritingModeContext.Provider, {
    value: value,
    children: props.children
  });
};
export const useWritingModeContext = () => {
  return useContext(WritingModeContext);
};

/**
 * @returns true if the application should render in right-to-left mode
 */
export function useIsRTL() {
  const writingMode = useContext(WritingModeContext);
  return writingMode.direction === 'rtl';
}
//# sourceMappingURL=WritingModeContext.js.map